import { Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import React from 'react';

import { type contextType, DynamicButtonContext } from 'components/DynamicButtons/DynamicButtons';
import Button from 'components/helpers/Button/Button';

import styles from './DynamicButtonBack.module.scss';

const cx = classNames.bind(styles);

type DynamicButtonBackProps = {
  controls: string;
  section: string;
};

const DynamicButtonBack = (props: DynamicButtonBackProps): React.JSX.Element => {
  const { controls, section } = props;
  const { backBtnLabel, setButtonClicked, setCurrentSection } = React.useContext(DynamicButtonContext) as contextType;
  const { sitecoreContext } = useSitecoreContext();

  return (
    <Button
      aria-controls={controls}
      className={cx('dynamic-button__back-btn')}
      icon="carat"
      type="button"
      onClick={() => {
        setButtonClicked(true);
        setCurrentSection(section);
      }}
    >
      <Text field={backBtnLabel} encode={sitecoreContext.pageEditing} />
    </Button>
  );
};

export default DynamicButtonBack;
